{
	"title": "Deklaracje",
	"table": {
		"material": "Materiał",
		"dateOfIssue": "Data wystawienia",
		"quantity": "Ilość",
		"carbonSavings": "Redukcje emisji CO\u2082",
		"status": {
			"title": "Status",
			"TransactionProcessing": "Przetwarzanie transakcji",
			"CreatingDeclaration": "Tworzenie deklaracji",
			"GenerationFailed": "Generowanie nie powiodło się",
			"ReadyToDownload": "Gotowe do pobrania"
		}
	},
	"declarationLanguageSelect": {
		"title": "Język deklaracji",
		"description": "Wybierz język deklaracji.",
		"label": "Język deklaracji",
		"buttonBack": "Wstecz",
		"buttonSave": "Zapisz"
	},
	"downloadAllLanguageSelect": {
		"title": "Języki deklaracji",
		"descriptionGlobal": "Wybierz język dla wszystkich deklaracji.",
		"descriptionIndividual": "Lub ustaw język dla każdej deklaracji osobno.",
		"label": "Języki deklaracji",
		"tableHeaderDeclaration": "Deklaracja (materiał/data wystawienia)",
		"tableHeaderLanguage": "Język deklaracji",
		"buttonBack": "Wstecz",
		"buttonDownload": "Pobierz deklaracje"
	},
	"declarationActions": {
		"changeLanguage": "Zmień język deklaracji",
		"preview": "Podgląd",
		"download": "Pobierz",
		"transaction": "Transakcja",
		"showMoreTransactions": "Pokaż więcej transakcji",
		"languageLabel": "Język deklaracji",
		"downloadAll": "Pobierz wszystkie deklaracje"
	}
}
